<template>
  <div id="app" class="app">
    <Navigation
      v-bind:class="{
        'black-nav': $route.path == '/blog'
      }"
    />
    <router-view />
    <FooterContent
      v-bind:class="{
        'remove-btn': $route.path == '/blog'
      }"
    />
  </div>
</template>
<script>
import Navigation from "@/components/Navigation.vue";
import FooterContent from "@/components/FooterContent.vue";

export default {
  name: "App",
  components: {
    Navigation,
    FooterContent
  },
  data() {
    return {};
  },
  mounted() {
    document.title = "Flow NFT Score";
    document.getElementById("favicon").href = `${window.location.origin}/favicon2.png`;
  }
};
</script>
